import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_GET_LISTING_BY_ID } from 'api/actionTypes';

export default async function setAddToTourListing({ state, apiClient }, { listingId }) {
  typeCheck('listingId::PositiveNumber', listingId);
  await apiClient.postWithState({
    action: SR_API_ACTION_GET_LISTING_BY_ID,
    state: state,
    payload: {
      listingId,
    },
    onSuccess(addToTourListing) {
      state.set(['addToTourListing'], addToTourListing);
      state.commit();
    },
  });
}
